import { useEffect } from 'react'

// Components
import { Text } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'
import MembershipCard from '@sections/v25/es/ft1/membership/membership-card/MembershipCard'

// Helpers
import { pin, ttpixel } from '@helpers/trackers'

interface MembershipWrapperProps {
  redirectURL?: string
}

const MembershipWrapper = ({
  redirectURL = '/v25/es/payment'
}: MembershipWrapperProps) => {
  useEffect(() => {
    ttpixel.trackEvent('ViewContent')
    pin.trackEvent('viewcategory', { serverEvent: 'view_category' })
  }, [])

  return (
    <Section padding={[32, 0]}>
      <Text
        tagName="h2"
        variant="title-2"
        spacing={{ sm: 8 }}
        align="center"
        transform="capitalize"
      >
        Empieza tu membresía hoy
      </Text>

      <Text tagName="p" variant="body-1" align="center" spacing={{ sm: 32 }}>
        ¡Únete a <b>más de 50.000</b> miembros y deja de pagar el precio
        completo!
      </Text>

      <MembershipCard redirectURL={redirectURL} />
    </Section>
  )
}

export default MembershipWrapper
